import type { TextareaProps } from "@gadgetinc/widgets";
import { Textarea } from "@gadgetinc/widgets";
import { merge, omit } from "lodash";
import { observer } from "mobx-react-lite";
import React from "react";
import type { BindingProps } from "./useBinding";
import { useBinding } from "./useBinding";
import type { DisabledOnProdProps } from "./useDisableProd";
import type { NodeWithProblems } from "./useProblemMessages";
import { useBoundNodeHasProblems } from "./useProblemMessages";

const BoundTextAreaInner = React.forwardRef(
  <Node extends NodeWithProblems>(
    props: TextareaProps & BindingProps<Node, string> & { $resizable?: boolean } & DisabledOnProdProps<Node>,
    ref: React.Ref<any>
  ) => {
    const [value, setValue] = useBinding(props);
    const { error } = useBoundNodeHasProblems(props);

    let overrides = props.overrides;
    if (props.$resizable) {
      overrides = merge(
        {
          Input: {
            style: {
              minHeight: "44px",
              height: "44px",
              resize: "vertical",
            },
          },
        },
        props.overrides
      );
    }

    return (
      <Textarea
        inputRef={ref}
        {...omit(props, ["property", "getter", "setter", "$resizable", "overrides"])}
        overrides={overrides}
        error={error}
        value={value || ""}
        onChange={(event) => {
          setValue(event.currentTarget.value);
        }}
      />
    );
  }
);
export const BoundTextArea = observer(BoundTextAreaInner);
